/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the original file in a separate folder. Call your working copy something like budget-gridcraft-test.xlsx. The browser editor on this site is pinned to v0.7.0, an alpha release; a newer desktop release may behave differently. Match your test to the version you actually intend to use.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把原文件保存在单独的文件夹中，将测试副本命名为 budget-gridcraft-test.xlsx 等。本网站的浏览器编辑器固定使用 Alpha 版本 v0.7.0；较新的桌面版本可能表现不同，应在计划使用的版本上进行测试。`)
};

/**
* | output |
* | --- |
* | "Keep the original file in a separate folder. Call your working copy something like budget-gridcraft-test.xlsx. The browser editor on this site is pinned to v..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_0_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_0_paragraphs_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.0.paragraphs.1" }